<div class="step1" [style.display]="ui.step() === 'pickFunction' ? 'block' : 'none'">
  <nav aria-label="breadcrumbs">
    <ol class="breadcrumb">
      <!-- Same empty-link defect as on the parameter form; see the comment there. -->
      <li class="breadcrumb-item home"><a href="/menu.html" class="bsrBack functionsLogo" data-transaction-name="Back" insp-label="Back" [title]="'itgen_gmr_main' | translate | decodeEntities" translate="itgen_gmr_home" (click)="ui.goToFunctionPicker($event)"></a></li>
    </ol>
  </nav>
  <h2 class="heading">
    <span translate="itgen_gmr_toolname"></span>
    <!-- A <span>, not the <img> this was until 2026-08-14. menu.css already paints .filterInputIcon with
         `background: url(/images/gmr-search.svg)` at 16x16, so the element was an <img> whose own src
         fetched the very same file a second time and then rendered underneath that background. Making it
         a span removes the duplicate request and the image-alt failure at once: a decorative search
         glyph next to a field labelled "Filter" has nothing to announce. -->
    <span class="filterInputIcon" aria-hidden="true"></span>
    <input id="filter-reports" class="filterInput" [(ngModel)]="functionsFilterModel" type="text" placeholder="Filter" autofocus />
  </h2>

  <div id="chooseFilter">
    <div class="form">
      @for (entry of filteredGroupedFunctions() | keyvalue: originalOrder; track entry.key)
      {
        <div class="reportGroup" [class.custom]="entry.value[0].can_custom_flag === true">
          <!-- The heading stays a heading and wraps a real <button>: the group is now operable by
               keyboard and its open/closed state is readable from aria-expanded, neither of which a
               <span>/<h4> with a click handler could offer. aria-controls names the list it opens.
               Level is <h3>, not <h4>: the page heading above it is an <h2>, and jumping a level fails
               the heading-order rule. The layout keys on .reportGroupHeading, not on the tag.
               The chevron keeps its click handler for the same hit area as before but is marked
               aria-hidden - it is a second control for the one thing the button already announces,
               and exposing both would make every group appear twice to anything enumerating controls.
               Keyed on can_description (the resource KEY, already lower-cased and underscored by
               GmrDataService) rather than on entry.key, which is the translated group label and would
               put spaces, colons and language-dependent text into an id. -->
          <div class="reportGroupHeader">
            <h3 class="reportGroupHeading">
              <button type="button" class="reportGroupToggle"
                      [id]="'group-tile-' + entry.value[0].can_description"
                      [attr.aria-expanded]="!isGroupCollapsed(entry.key)"
                      [attr.aria-controls]="'group-tile-list-' + entry.value[0].can_description"
                      (click)="toggleGroupCollapse(entry.key)"
                      [translate]="entry.value[0].can_description"></button>
            </h3>
            <span class="closeGroup" aria-hidden="true" [class.collapse]="isGroupCollapsed(entry.key)" (click)="toggleGroupCollapse(entry.key)"></span>
          </div>
          <ul class="functions" [id]="'group-tile-list-' + entry.value[0].can_description" [style.display]="isGroupCollapsed(entry.key) ? 'none' : 'grid'">
            @for (fn of entry.value; track fn.cfn_code)
            {
              <li>
                @if (entry.value[0].can_custom_flag === true)
                {
                  <span class="customLabel">custom</span>
                }
                <!-- `tile-` prefix: the sidebar renders a link to this same report, and both used to
                     carry id="<preset name>" verbatim - 41 duplicate ids on one page, with
                     getElementById() answering with the sidebar's copy, which is display:none whenever
                     its group is collapsed. See ai/DATAMODEL.md § 4. -->
                <a class="functionButton" href="#preset={{ fn.cfn_preset_name }}" [id]="'tile-' + fn.cfn_preset_name"
                   [class.icon]="fn.cfn_icon_url != null" [class.goParam]="fn.cfrstat_cnt >= 1"
                   [attr.data-value]="fn.cfn_code" [attr.data-preset-name]="fn.cfn_preset_name"
                   [title]="(fn.cfn_description | translate) | decodeEntities"
                   (click)="selectFunction(fn)">
                  <img [src]="fn.cfn_icon_url" [alt]="(fn.cfn_description | translate) | decodeEntities" [title]="(fn.cfn_description | translate) | decodeEntities" />
                  <span class="functionDescription" [translate]="fn.cfn_description"></span>
                </a>
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
</div>

<ng-content select="[step2]"></ng-content>
